import PaginationData from './PaginationData';
/**
 * 백엔드 응답값 의존성을 끊기 위한 레이어
 */
class PaginationOutput {
    paginationData = {
        total: 0,
        pageNum: 0,
        pageNumber: 1,
        pageSize: 0,
        size: 0,
        startRow: 0,
        endRow: 0,
        pages: 0,
        prePage: 0,
        nextPage: 0,
        hasNextPage: false,
        hasPreviousPage: false,
    };
    /** 조회 리스트 */
    list = [];
    /** 추가 데이터 필요시 */
    extraData = {};
    /**
     * backend api의 응답값을 받아서 프론트엔드에서 사용할 데이터구조로 변환하여 인스턴스 반환
     * 아답터 역할과 팩토리 역할을 병행합니다
     * @param res backend 응답값 객체
     * @param Cls 클래스 인스턴스
     */
    static adaptorFactory(res, Cls) {
        const { data } = res.data;
        // 서버에서 페이지네이션 없이 data에 모든 값을 줄 때가 있음. 해당 케이스 대응
        if (Array.isArray(data)) {
            return new PaginationOutput({
                list: data,
            }, Cls);
        }
        return new PaginationOutput(data, Cls);
    }
    constructor(data = {}, Cls) {
        this.paginationData = new PaginationData({
            total: data.total || data.totalElements || 0,
            pageNum: data.pageNum || 0,
            pageNumber: data.pageNum || data.pageNumber || 1,
            pageSize: data.pageSize || 0,
            size: data.size || data.pageSize || 0,
            startRow: data.startRow || 0,
            endRow: data.endRow || 0,
            pages: data.pages || data.totalPages || 0,
            prePage: data.prePage || 0,
            nextPage: data.nextPage || 0,
            hasNextPage: data.hasNextPage || 0,
            hasPreviousPage: data.hasPreviousPage || 0,
        });
        this.list = data.list ?? [];
        if (Cls) {
            this.list = this.list.map((item) => (new Cls(item)));
        }
        this.extraData = {
            ...data.rest,
        };
    }
}
export default PaginationOutput;
